import {createContext, useState, useContext, ReactNode, useEffect} from 'react';
import {ProfileModel} from "../features/profile/profileTypes";
import {useLoggedUser} from "./LoggedUserContext";

interface ProfileContextType {
    isLoggedUser: boolean;
    profile: ProfileModel | null;
    setProfile: (profile: ProfileModel) => void;
    edit: boolean;
    setEdit: (edit: boolean) => void;
}

const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

export const ProfileProvider = ({ children }: { children: ReactNode }) => {
    const [profile, setProfile] = useState<ProfileModel | null>(null);
    const [edit, setEdit] = useState<boolean>(false);
    const [isLoggedUser, setIsLoggedUser] = useState<boolean>(false);
    const { user } = useLoggedUser();

    useEffect(() => {
        if (user && profile) {
            setIsLoggedUser(user.id === profile.id)
        }
    }, [user, profile]);

    return (
        <ProfileContext.Provider value={{ profile, setProfile, edit, setEdit, isLoggedUser }}>
            {children}
        </ProfileContext.Provider>
    );
};

export const useProfile = () => {
    const context = useContext(ProfileContext);

    if (context === undefined) {
        throw new Error('Context is undefined');
    }

    return context;
};
